import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../assets/locale/messages";
import EmptyState from "../../../components/EmptyState";
import { getBooksDashboardResponse } from "../../../store/Dashboard/actions";
import Table from "../../../components/Table";
import TableContainer from "@material-ui/core/TableContainer";
import { Formik, Form } from "formik";
import Search from "../../../components/Search";
import BookSingleRow from "../BookSingleRow";
import Title_Section from "../../../components/Title_Section/Title_Section";

function BookDetails() {
  const dispatch = useDispatch();

  const booksList = useSelector((state) => state.dashboard.list);
  const lang = useSelector((state) => state.locale.lang);
  const isLoading = useSelector((state) => state.loader);

  useEffect(() => {
    dispatch(getBooksDashboardResponse());
  }, []);

  const {
    books: { title, bookTitle, isbn, bookReleaseDate }
  } = messages[lang];
  const [searchName, setsearchName] = useState("");

  const filteredBooks = useMemo(() => {
    if (!searchName) return booksList;

    return booksList.filter((item) =>
      item.book.title.toLowerCase().includes(searchName.toLowerCase())
    );
  }, [booksList, searchName]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mt-4">
        <Title_Section title={title} />
        <Formik>
          {() => (
            <Form>
              <Search
                name="search"
                placeholder="Search"
                onChange={(e) => setsearchName(e.target.value)}
              />
              <button className="d-none"></button>
            </Form>
          )}
        </Formik>
      </div>
      <TableContainer>
        <Table
          headlines={["", bookTitle, bookReleaseDate, isbn]}
          rows={filteredBooks.map((row) => (
            <BookSingleRow key={row.book.id} row={row} />
          ))}
        />
      </TableContainer>
      {!isLoading && !booksList.length && <EmptyState />}
    </>
  );
}

export default BookDetails;
